/**
 * Interceptor
 * This is ErrorHandlerInterceptor that adds a default error handler to all requests.
 */
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { UNAUTHORIZED, FORBIDDEN } from 'http-status-codes';
import { appRoutes } from '@app/configs/route-paths-const.config';
import { PubSubService } from '../services/pub-sub-service/pub-sub.service';
import { isExternalUrl } from '../helpers/utils';
import { environment } from '@environment/environment';
import { CommonAlertService } from '../services/common-alert.service/common-alert.service';
/**
 * Creates a ErrorHandlerInterceptor.
 * @class ErrorHandlerInterceptor
 * @description
 *  This class is used to add error handler for all api requests
 */

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {


  isExcludeUrl = false;
  constructor(private router: Router,
    private pubsubService: PubSubService,
    private commonAlert : CommonAlertService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.isExculdeUrl(request.url) && !this.skipLoader(request)) {
      this.pubsubService.startStopLoader(true);
    }
    return next.handle(request).pipe(tap(res => this.responseHandler(res, false)), catchError(error => this.responseHandler(error, true)));
  }

  /**
   * skip loader
   * @param request 
   * @returns 
   */
  skipLoader(request: any) {
    try {
      const url = request.url
      const skipLoader = '=skipLoader';
      const isSkipLoader = url.includes(skipLoader)
      if (isSkipLoader) {
        request.url = url.replace(skipLoader, '');
        return true;
      }
    } catch (error) { }
  }

  /**
   * used to handle the response
   * @param res 
   */
  private responseHandler(res: HttpEvent<any>, isError: boolean) {
    if (res instanceof HttpResponse || res instanceof HttpErrorResponse) {
      if (!this.isExculdeUrl(res.url)) {
        //check version and show popup if changed
        this.pubsubService.startStopLoader();
        this.handleAppVersion(res);
      }
    }
    if (isError) {
      return this.errorHandler(res);
    }
  }

  isNewVersion = false;
  async handleAppVersion(res: any) {
    try {
      const appVersion = +(res.headers.get('app-version'));
      if(appVersion === 0) return;
      const currentVersion = environment.version;
      if (!this.isNewVersion && appVersion !== currentVersion) {
        this.isNewVersion = true;
        this.commonAlert.newVersion();
      }
      console.log(`app_v:${currentVersion}_api_v:${appVersion}`)
    } catch (error) {
      console.error('handleAppVersion', error);
    }
  }


  /**
  * Customize the default error handler here if needed
  * @param {error} HttpEvent
  * @returns Http error Object
  */
  private errorHandler(error: any): Observable<HttpEvent<any>> {
    this.pubsubService.startStopLoader();
    const httpErrorCode = error['status'];
    if (!isExternalUrl(error.url)) {
      switch (httpErrorCode) {
        case UNAUTHORIZED:
          this.router.navigateByUrl(appRoutes.login);
          break;
        // case FORBIDDEN:
        //   this.router.navigateByUrl(appRoutes.forbidden);
        //   break;
        // case NOT_FOUND:
        //   this.router.navigateByUrl(appRoutes.notFound);
        //   break;
      }
    }
    return throwError(error);
  }

  isExculdeUrl(apiurl: string) {
    if (apiurl) {
      let pageUrl = location.href;
      let excludeLoader = [
        'check-email',
        'session/room',
        'refresh-token',
        'broadcast-settings',
        'googleapis.com'
      ];
      let res = excludeLoader.some(p => apiurl.includes(p) || pageUrl.includes(p));
      return res;
    }
    return false;
  }



}

